<template>
    <div v-if="$page.props.error" class="mb-4 bg-red-200 p-4 text-red-600">
        <span>{{$page.props.error}}</span>
    </div>

    <div v-show="$page.props.success" class="text-white px-6 py-4 relative mb-4 bg-green-500">
        <span>{{$page.props.success}}</span>
    </div>
</template>
<script>
export default {

}
</script>